import { AccordionItem } from 'common';
import React from 'react';
import { NavLink } from 'react-router-dom';
import './AssociatedConcept.scss';
function AssociatedConcept({ concept }) {
    const Header = () => {
        var _a;
        return (React.createElement("div", { className: "associated-concept__header" },
            ((_a = concept === null || concept === void 0 ? void 0 : concept.badge) === null || _a === void 0 ? void 0 : _a.image) && (React.createElement("img", { className: "associated-concept__header__badge", src: concept.badge.image })),
            React.createElement("h4", { className: "associated-concept__header__heading" }, concept.heading)));
    };
    return (React.createElement(AccordionItem, { header: React.createElement(Header, null), className: "associated-concept" },
        React.createElement("p", { className: "associated-concept__content" }, concept.description),
        React.createElement(NavLink, { className: "associated-concept__link", to: `/${concept.identifier}` }, "Les mer.")));
}
export default AssociatedConcept;
